import { react2angular } from 'react2angular';
import UpdateExistingShowingsModal from './UpdateExistingShowingsModal';

angular
  .module('bb.appointments')
  .component(
    'bbUpdateExistingShowingsModal',
    react2angular(UpdateExistingShowingsModal, [
      'listingId',
      'visible',
      'excludedShowings',
      'hideModal',
      'saveForm',
      'showingsConfig',
    ]),
  );
